import validate from 'validate.js'

const constraints = {
  serviceId: {
    presence: true
  },
  topicIds: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
